import React from 'react';
export type StatusBar = {
  status: string;
  count: number;
  volume: string;
};
type StatusBarChartProps = {
  title: string;
  bars: StatusBar[];
  onSelect: (status: string) => void;
};
export function StatusBarChart({
  title,
  bars,
  onSelect
}: StatusBarChartProps) {
  const max = Math.max(1, ...bars.map(bar => bar.count));
  return <section className="flex h-full flex-col rounded-xl border border-gray-200 bg-white" data-id="element-683" data-mp="22mvjhx7rqtdu">
      <header className="border-b border-gray-200 px-5 py-3.5" data-id="element-684" data-mp="150y80jrt3obe">
        <h2 className="text-[14px] font-semibold text-ink" data-id="element-685" data-mp="19y6qklgv9ud6">{title}</h2>
        <p className="mt-0.5 text-[12.5px] text-gray-500" data-id="element-686" data-mp="19wdeurrecjyb">
          Select a status to see the records behind it.
        </p>
      </header>

      <div className="flex flex-1 items-end gap-3 px-5 pb-3 pt-6" data-id="element-687" data-mp="1jpkvj8rl7mdp">
        {bars.map(bar => <button key={bar.status} type="button" onClick={() => onSelect(bar.status)} className="group flex min-w-0 flex-1 flex-col items-center gap-2 focus:outline-none" aria-label={`${bar.status}: ${bar.count} records`} data-id="element-688" data-mp="m82m6bvutql4">
            <span className="text-[12px] font-semibold text-ink" data-id="element-689" data-mp="2taissjbtb0fj">{bar.count}</span>
            <span className="flex h-[132px] w-full items-end" data-id="element-690" data-mp="2ojk9rbzfvo8l">
              <span className="w-full rounded-t bg-brand/85 transition-colors group-hover:bg-brand group-focus-visible:bg-brand" style={{
            height: `${Math.max(4, bar.count / max * 100)}%`
          }} data-id="element-691" data-mp="2ohzcvfpnjt7k" />
            </span>
            <span className="w-full truncate text-center text-[11px] text-gray-600" data-id="element-692" data-mp="2aj9g616qvvjq">
              {bar.status}
            </span>
            <span className="w-full truncate text-center text-[10.5px] text-gray-400" data-id="element-693" data-mp="25lgcbeswzdmm">
              {bar.volume}
            </span>
          </button>)}
        {bars.length === 0 && <p className="w-full px-5 py-12 text-center text-[12.5px] text-gray-500" data-id="element-694" data-mp="3t1x4nhr8n9w">
            No records in this pipeline.
          </p>}
      </div>
    </section>;
}